import { render, staticRenderFns } from "./ConsultarComprovanteDeposito.vue?vue&type=template&id=6394bb90&"
import script from "./ConsultarComprovanteDeposito.vue?vue&type=script&lang=js&"
export * from "./ConsultarComprovanteDeposito.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports